import {
  createKidsPost,
  createKidsPostComment,
  deleteKidsPost,
  deleteKidsPostComment,
  fetchKidsPostComments,
  fetchKidsPosts,
  setKidsPostCommentLike,
  setKidsPostLike,
} from '../apis/kidsPost';
import type { CommunityFeed } from '../types/community.types';
import type { KidsPost, KidsPostComment, NewKidsPost } from '../types/kidsPost.types';
import {
  type CommunityBoard,
  useCommunityComments,
  useCommunityPages,
  useCreateCommunityComment,
  useCreateCommunityPost,
  useDeleteCommunityComment,
  useDeleteCommunityPost,
  useLikeCommunityComment,
  useLikeCommunityPost,
} from './useCommunityBoard';

// Calls go through the module at call time (the tests mock only what they use)
const KIDS_POSTS: CommunityBoard<KidsPost, KidsPostComment, NewKidsPost> = {
  feedsKey: 'kids-posts',
  commentsKey: 'kids-post-comments',
  fetchPosts: (feed, page, size) => fetchKidsPosts(feed, page, size),
  createPost: (input) => createKidsPost(input),
  deletePost: (postId) => deleteKidsPost(postId),
  setPostLike: (postId, liked) => setKidsPostLike(postId, liked),
  fetchComments: (postId, page, size) => fetchKidsPostComments(postId, page, size),
  createComment: (postId, content) => createKidsPostComment(postId, content),
  deleteComment: (postId, commentId) => deleteKidsPostComment(postId, commentId),
  setCommentLike: (postId, commentId, liked) => setKidsPostCommentLike(postId, commentId, liked),
};

/** Timeline or Postingan Saya pages. */
export const useKidsPostPages = (feed: CommunityFeed) => useCommunityPages(KIDS_POSTS, feed);

/** Every comment of a post, oldest first; nothing is requested until `enabled`. */
export const useKidsPostComments = (postId: string, enabled: boolean) =>
  useCommunityComments(KIDS_POSTS, postId, enabled);

export const useCreateKidsPost = () => useCreateCommunityPost(KIDS_POSTS);
export const useDeleteKidsPost = () => useDeleteCommunityPost(KIDS_POSTS);
export const useLikeKidsPost = () => useLikeCommunityPost(KIDS_POSTS);
export const useCreateKidsPostComment = () => useCreateCommunityComment(KIDS_POSTS);
export const useDeleteKidsPostComment = () => useDeleteCommunityComment(KIDS_POSTS);
export const useLikeKidsPostComment = () => useLikeCommunityComment(KIDS_POSTS);
